import actionTypes from './actionTypes';
import { ContactsApi } from '../../api/contacts';

const api = new ContactsApi();

export const loadContacts = () => async dispatch => {
    try{
        dispatch({type: actionTypes.LOAD_CONTACTS_START, payload: {}});
        
        const {data} = await api.getContactsList();

        return dispatch({type: actionTypes.LOAD_CONTACTS_SUCCESS, payload: {data}});

    }catch(error){
        return dispatch({type: actionTypes.LOAD_CONTACTS_FAIL, payload: {error}});
    }
};